// @flow

import * as React from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Config from "../../constants/Config";
import { quickRegistration } from "../../actions/cart";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import useSimpleNav from "../../hooks/useSimpleNav";
import Store from "../../store";
// import { CSSTransition, SwitchTransition } from "react-transition-group";

import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as RingMobile } from "../../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-detail-fill.svg";
import useAsyncState from "../../hooks/useAsyncState";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import Routes from "../../constants/Routes";
import Button from "../atoms/Button";
import { PrimaryNavPad } from "./PrimaryNav";
import Image from "../atoms/Image";
import { customValidators } from "../../utils/validators";

const RegistrationForm = props => {
    const { clubQuickRegistration } = useSelector(
        (state: any): any => state.cart
    );

    return (
        <div className="quick-registration-body__form">
            <div className="container-fluid">
                <div className="quick-registration-body__row row">
                    <div className="col-xs-12 col-md-6 col-md-offset-2">
                        <div className="quick-registration-body__form__inner">
                            <p className="quick-registration-body__form__description">
                                Students & staff: use your UTS email
                            </p>
                            <ServerErrorMessage>
                                {props.error}
                            </ServerErrorMessage>
                            <ReactForm
                                className={props.error ? "is-invalid" : ""}
                                onSuccess={props.handleQuickRegSubmit}
                                validators={customValidators}
                            >
                                <ReactFormField
                                    type="email"
                                    label="Email"
                                    name="email"
                                    required={true}
                                    validators={["email"]}
                                    defaultValue={
                                        clubQuickRegistration.remember
                                            ? clubQuickRegistration.email
                                            : ""
                                    }
                                />
                                <ReactFormField
                                    type="text"
                                    label="First name"
                                    name="first_name"
                                    validators={["customname"]}
                                    required={true}
                                    defaultValue={
                                        clubQuickRegistration.remember
                                            ? clubQuickRegistration.first_name
                                            : ""
                                    }
                                />
                                <ReactFormField
                                    type="text"
                                    label="Last name"
                                    name="last_name"
                                    validators={["customname"]}
                                    required={true}
                                    defaultValue={
                                        clubQuickRegistration.remember
                                            ? clubQuickRegistration.last_name
                                            : ""
                                    }
                                />
                                <ReactFormField
                                    type="text"
                                    label="Phone"
                                    name="mobile"
                                    validators={["phonenumber"]}
                                    defaultValue={
                                        clubQuickRegistration.remember
                                            ? clubQuickRegistration.mobile
                                            : ""
                                    }
                                />

                                <div className="login-profile-body__form__footer">
                                    <ReactFormField
                                        className="react-form__field--remember"
                                        type="checkbox"
                                        label="Remember me"
                                        name="remember"
                                        defaultChecked={
                                            clubQuickRegistration.remember
                                        }
                                    />
                                </div>

                                <Button
                                    type="submit"
                                    styles={["green"]}
                                    aria-label="Next"
                                    loading={props.loading}
                                    success={!!props.success}
                                >
                                    Next
                                </Button>
                            </ReactForm>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SuccessRegistration = props => {
    const history = useHistory();

    const navigateNewMember = () => {
        history.push(`${document.location.pathname}?quickRegistration=true`);
        props.refreshParams(true);
    };

    return (
        <div className="quick-registration-body__success">
            <div className="container-fluid">
                <div className="quick-registration-body__row row">
                    <div className="col-xs-12 col-md-6 col-md-offset-2">
                        <div className="quick-registration-body__success__inner">
                            <p className="quick-registration-body__success__description">
                                {props.loggedIn ? (
                                    <>
                                        Thanks for joining. You can now see your
                                        club memberships in your account.
                                    </>
                                ) : (
                                    <>
                                        Thanks for joining. Sign up or log in to
                                        the ActivateUTS website using the same
                                        email to see all your club memberships.
                                    </>
                                )}
                            </p>
                            {props.loggedIn ? (
                                <Button
                                    styles={["green"]}
                                    aria-label="My Clubs"
                                    to={Config.routes.currentMembership}
                                >
                                    My Clubs
                                </Button>
                            ) : (
                                <Button
                                    styles={["green"]}
                                    aria-label="Activate UTS Homepage"
                                    to={Config.routes.login}
                                >
                                    Login or sign up
                                </Button>
                            )}
                        </div>
                        <div className="quick-registration-body__success__outer">
                            For club executives:{" "}
                            <button
                                type="button"
                                className="link"
                                onClick={() => navigateNewMember()}
                            >
                                Sign up another member
                            </button>{" "}
                            (Must be logged out)
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HasMembershipError = props => {
    const history = useHistory();

    const navigateClosed = () => {
        history.push(props.cta.url);
        props.refreshParams(true);
    };

    return (
        <div className="quick-registration-body__already-member">
            <div className="container-fluid">
                <div className="quick-registration-body__row row">
                    <div className="col-xs-12 col-md-6 col-md-offset-2">
                        <div className="quick-registration-body__already-member__inner">
                            <p className="quick-registration-body__already-member__description">
                                {props.description}
                            </p>
                            <Button
                                styles={["green"]}
                                aria-label={props.cta.text}
                                onClick={navigateClosed}
                            >
                                {props.cta.text}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const QuickRegistrationBody = (props): React.Node => {
    const baseClassName = "quick-registration-body";
    const classes = [baseClassName];

    const { profile, loggedIn } = useSelector((state: any): any => state.user);
    const reduxState = Store.getState();
    const dispatch = useDispatch();
    const history = useHistory();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [state, localActions] = useAsyncState();

    if (props.acf.theme) {
        classes.push(`${baseClassName}--${props.acf.theme}`);
    }

    useSimpleNav();

    const { hero } = props.acf;
    const related = _.get(reduxState, `page.related`) || {};

    const hasMembership =
        profile && profile.active_memberships
            ? profile.active_memberships.filter(
                  memberships => memberships.club_id === props.ID
              ).length > 0
            : false;

    const memberships = props.acf.club_products.map(
        product => related[product.product.ID]
    );

    const memDesc = memberships.map((membership, i) => {
        return (
            <span key={i}>
                {membership.meta_data[1].value + " : $" + membership.price}
                {i + 1 < memberships.length ? ", " : ""}
            </span>
        );
    });

    const handleQuickRegSubmit = async (formData: any): any => {
        if (!executeRecaptcha) {
            localActions.fail("reCAPTCHA is still loading. Please try again.");
            return;
        }

        const googleRecaptchaResponse = await executeRecaptcha(
            "quick_registration"
        );

        localActions.request();
        dispatch(
            quickRegistration({
                ...formData,
                clubId: props.ID,
                clubUrl: `${document.location.pathname}${document.location.search}`,
                recaptcha_token: googleRecaptchaResponse,
            })
        )
            .then(() => {
                history.push(Routes.checkout);
            })
            .catch((error: any) => {
                console.error(error);
                localActions.fail(
                    error.message ||
                        "There was an issue signing up for this club."
                );
            });
    };

    return (
        <div className={classes.join(" ")}>
            <div className="quick-registration-body__inner">
                <PrimaryNavPad />
                <div className="quick-registration-body__container container-fluid">
                    {/* Design elements */}
                    <Circle className="quick-registration-body__circle" />
                    <Ring className="quick-registration-body__ring" />
                    <RingMobile className="quick-registration-body__ring-mobile" />

                    <div className="quick-registration-body__row row">
                        <div className="col-xs-12 col-md-8 col-md-offset-2">
                            <div className="quick-registration-body__logo">
                                <Image
                                    src={hero.logo.url}
                                    alt="Logo"
                                    aspectRatio="1:1"
                                />
                            </div>
                            {props.checkout ? (
                                <div className="quick-registration-body__header">
                                    <h2 className="quick-registration-body__title">
                                        Welcome to {props.post_title}!
                                    </h2>
                                </div>
                            ) : (
                                <div className="quick-registration-body__header">
                                    <h2 className="quick-registration-body__title">
                                        Join {props.post_title}
                                    </h2>
                                    <p className="quick-registration-body__description">
                                        {memDesc}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {props.acf.open_state === "closed" ||
            props.acf.open_state === "not-possible" ? (
                <HasMembershipError
                    refreshParams={props.refreshParams}
                    description="New memberships for this club are currently closed, please contact the club directly for more information."
                    cta={{
                        text: "See club details",
                        url: document.location.pathname,
                    }}
                />
            ) : props.checkout ? (
                <SuccessRegistration
                    loggedIn={loggedIn}
                    refreshParams={props.refreshParams}
                />
            ) : hasMembership ? (
                <HasMembershipError
                    refreshParams={props.refreshParams}
                    description="You're already a member of this club."
                    cta={{
                        text: "View my club memberships",
                        url: Config.routes.currentMembership,
                    }}
                />
            ) : (
                <RegistrationForm
                    error={state.error}
                    loading={state.loading}
                    success={state.success}
                    handleQuickRegSubmit={handleQuickRegSubmit}
                />
            )}
        </div>
    );
};

export default QuickRegistrationBody;
